import { useSelector } from 'react-redux';

import getCompanyServices from '@/API/getCompanyServices';
import { useQuery } from 'hooks/useCustomQuery';

const VENDOR_DEFINED = 'VendorDefined';

/**
 * The current company's vendor-defined service, if it has one.
 *
 * This was previously merged into `navigationLists.currentCompanyData` by
 * Searchbar, even though it comes from `/company/{id}/services` rather than
 * `/company/{id}`. Keyed to match Searchbar's own query so both share one
 * cache entry and one request.
 *
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
const useGetCurrentCompanyVendorService = () => {
    const { currentCompany } = useSelector((state) => state.navigationLists);

    return useQuery({
        queryKey: ['services', `company: ${currentCompany}`],
        queryFn: async () => {
            const res = await getCompanyServices(currentCompany);
            if (res.status !== 200) {
                throw new Error('Error fetching services');
            }
            return res.data;
        },
        select: (services) =>
            services?.find(
                (service) => service?.serviceType === VENDOR_DEFINED,
            ) ?? null,
        enabled: Boolean(currentCompany),
        refetchOnWindowFocus: false,
    });
};

export default useGetCurrentCompanyVendorService;
